import { z } from 'zod';
import { idSchema } from './commun.js';
export const PRIX_CATALOGUE = ['regle_oeuvre', 'afficher', 'masquer'];
export const PRIX_OEUVRE_CATALOGUE = ['herite', 'afficher', 'masquer'];
const texteCatalogueSchema = z.strictObject({
    fr: z.string().max(4000),
    en: z.string().max(4000).optional(),
});
const texteSalleSchema = z.strictObject({
    fr: z.string().max(2000),
    en: z.string().max(2000).optional(),
});
export const oeuvreCatalogueVisiteEntreeSchema = z.strictObject({
    oeuvreId: idSchema,
    masquee: z.boolean(),
    prix: z.enum(PRIX_OEUVRE_CATALOGUE),
    texteSalle: texteSalleSchema,
});
export const catalogueVisiteMiseAJourSchema = z.strictObject({
    publie: z.boolean(),
    visibleJusquAu: z.iso.datetime({ offset: true }).nullable(),
    prix: z.enum(PRIX_CATALOGUE),
    texte: texteCatalogueSchema,
    accuseReception: z.boolean(),
    oeuvres: z.array(oeuvreCatalogueVisiteEntreeSchema).max(200),
    revision: z.int().min(0),
});
export function echeanceParDefaut(finLe) {
    if (finLe === null)
        return null;
    const echeance = new Date(finLe);
    echeance.setUTCDate(echeance.getUTCDate() + 30);
    echeance.setUTCHours(23, 59, 59, 999);
    return echeance;
}
export function etatCatalogue(catalogue, maintenant) {
    if (!catalogue.publie)
        return 'brouillon';
    if (catalogue.visibleJusquAu !== null && maintenant >= catalogue.visibleJusquAu)
        return 'echu';
    return 'publie';
}
export function prixAffiche(choix) {
    if (choix.prixPublicCentimes == null || !(choix.prixPublicCentimes > 0))
        return false;
    if (choix.prixOeuvreCatalogue !== 'herite')
        return choix.prixOeuvreCatalogue === 'afficher';
    if (choix.prixCatalogue !== 'regle_oeuvre')
        return choix.prixCatalogue === 'afficher';
    return choix.prixVisibleOeuvre;
}
export function pastilleStatut(statut) {
    if (statut === 'reservee' || statut === 'vendue')
        return statut;
    return null;
}
//# sourceMappingURL=catalogue-visite.js.map